import { render, staticRenderFns } from "./KAM005-v1.vue?vue&type=template&id=3f4f6980&scoped=true"
import script from "./KAM005-v1.vue?vue&type=script&lang=ts"
export * from "./KAM005-v1.vue?vue&type=script&lang=ts"
import style0 from "./KAM005-v1.vue?vue&type=style&index=0&id=3f4f6980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4f6980",
  null
  
)

export default component.exports